/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRegularExpression = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 16a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM18 2v3l2.4-1.8 1.2 1.6-3.077 2.308 2.184 2.185-1.414 1.414L17 8.415l-2.293 2.292-1.414-1.414 2.183-2.185L12.4 4.8l1.2-1.6L16 5.001V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRegularExpression as RegularExpression };
